export default __webpack_public_path__ + "static/media/lightWordIcon.b300f572.svg";